import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'
import { checkRoutePermission } from '@/utils/auth.js'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/Home.vue'),
        meta: {
            title: '市場'
        }
    },
    {
        path: '/markets',
        name: 'Markets',
        component: () => import('@/views/Markets.vue'),
        meta: {
            title: '市場列表'
        }
    },
    {
        path: '/portfolio',
        name: 'Portfolio',
        component: () => import('@/views/Portfolio.vue'),
        meta: {
            requireAuth: true,
            permissions: ['bet', 'view_market'],
            title: '我的投資組合'
        }
    },
    {
        path: '/markets/:id',
        name: 'MarketDetail',
        component: () => import('@/views/MarketDetail/MarketDetail.vue'),
        meta: {
            title: '市場詳情'
        }
    },
    {
        path: '/user',
        name: 'User',
        component: () => import('@/views/User/UserProfile.vue'),
        meta: {
            requireAuth: true,
            permissions: ['manage_profile'],
            title: '個人中心'
        }
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('@/views/Admin/Admin.vue'),
        meta: {
            requireAuth: true,
            roles: ['ADMIN', 'OPERATOR'],
            title: '管理面板'
        }
    },
    // 404页面
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue'),
        meta: {
            title: '頁面不存在'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()

    // 设置页面标题
    if (to.meta.title) {
        document.title = `${to.meta.title} - Mana Trading`
    }

    // 检查路由权限
    const routePermission = {
        requireAuth: to.meta.requireAuth,
        permissions: to.meta.permissions,
        roles: to.meta.roles
    }

    const hasPermission = checkRoutePermission(
        routePermission,
        authStore.user?.role_code,
        authStore.isAuthenticated
    )

    if (!hasPermission) {
        if (!authStore.isAuthenticated) {
            // 未登录，跳转到首页（可以在首页显示登录模态框）
            next({
                path: '/',
                query: { redirect: to.fullPath } // 保存重定向路径
            })
        } else {
            // 已登录但权限不足，跳转到403页面或首页
            console.warn('权限不足，无法访问该页面')
            next({ path: '/' })
        }
        return
    }

    next()
})

// 全局后置钩子
router.afterEach((to, from) => {
    // 可以在这里添加页面访问统计等逻辑
    console.log(`导航到: ${to.path}`)
})

export default router
